import {
  Backdrop,
  Box,
  Divider,
  Fade,
  makeStyles,
  Modal,
  Typography,
} from "@material-ui/core";
import componentStyles from "assets/theme/views";
import { IsMobile } from "utils/is-mobile";

import CloseIcon from "@mui/icons-material/Close";
import ParseJson from "utils/parseJson";

const useStyles = makeStyles(componentStyles);

export default function ModalLogDetail({ log, handleClose }) {
  const isMobile = IsMobile();
  const classes = useStyles();

  const logDetail = ParseJson(log?.log);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={Boolean(log)}
      onClose={() => handleClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      style={{
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Fade in={Boolean(log)}>
        <div
          className={classes.paper}
          style={{
            backgroundColor: "#FFF",
            padding: "20px",
            width: isMobile ? "90%" : "70%",
            maxHeight: "90vh",
            borderRadius: 8,
          }}
        >
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: isMobile ? 0 : "1rem",
              cursor: "pointer",
              justifyContent: "flex-end",
            }}
            onClick={() => handleClose()}
          >
            <Typography variant="caption">Fechar</Typography>
            <CloseIcon
              onClick={() => handleClose()}
              style={{ marginLeft: "0.5rem" }}
            />
          </Box>

          <Box
            style={{
              marginBottom: "1rem",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography variant="h3">
              <strong>Informações Gerais:</strong>
            </Typography>
            <Typography variant="caption">
              <strong>Data:</strong> {log?.createdAt || "-"}
            </Typography>
            <Typography variant="caption">
              <strong>Status:</strong> {log?.status || "-"}
            </Typography>
            <Typography variant="caption">
              <strong>Linhas Processadas:</strong> {log?.processedLines || 0}
            </Typography>
            <Typography variant="caption">
              <strong>Total de Linhas:</strong> {log?.totalLines || 0}
            </Typography>
          </Box>

          <Divider style={{ marginBottom: "1rem" }} />

          <Box>
            <Typography variant="h3">
              <strong>Detalhes do Log:</strong>
            </Typography>

            {logDetail ? (
              <div>
                {logDetail.error ? (
                  <div>
                    <Typography variant="caption" color="error">
                      ⚠️ {logDetail.error}
                    </Typography>

                    <Typography
                      variant="body2"
                      component="pre"
                      style={{
                        backgroundColor: "#f5f5f5",
                        padding: "15px",
                        borderRadius: "4px",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        fontSize: "0.8rem",
                        marginTop: "10px",
                        border: "1px solid #ddd",
                        maxHeight: "40vh",
                        overflow: "auto",
                        display: "block",
                      }}
                    >
                      {logDetail.originalContent}
                    </Typography>
                  </div>
                ) : (
                  <Typography
                    variant="body2"
                    component="pre"
                    style={{
                      backgroundColor: "#ffcfd2",
                      padding: "15px",
                      borderRadius: "4px",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      fontSize: "0.9rem",
                      border: "1px solid #DF767D",
                    }}
                  >
                    {JSON.stringify(logDetail.mensagem, null, 2)}
                  </Typography>
                )}
              </div>
            ) : (
              <Typography
                variant="body2"
                style={{ fontStyle: "italic", color: "#666" }}
              >
                Nenhum detalhe de log disponível
              </Typography>
            )}
          </Box>
        </div>
      </Fade>
    </Modal>
  );
}
